import { sortGroups } from '../utils/scoreUtils';

const useFilteredGroups = (scoreData, sortDescending) => {
  if (!scoreData) return [];
  const sortedGroups = sortGroups(scoreData.seasonScoreGroups, sortDescending);
  return sortedGroups.filter(([, users]) => 
    Object.values(users).some(user => user.points > 0)
  );
};

export default useFilteredGroups;